import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import { router } from "@/spa/router";

import "@/spa/fonts.css";
import "@/globals.css";

const host = document.getElementById("root");
if (!host) throw new Error("index.html is missing #root");

createRoot(host).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
